import enLanguageTranslations from '../../multilanguage/en-US.json'

const getTranslations = () => {
  return Promise.resolve(enLanguageTranslations)
}

export default getTranslations